export function ConfirmMe(title,html) {
	if(title == undefined) {
		title = "confirm";
	}

	if(html == undefined) {
		html = "";
	}

	return new Promise((resolve, reject) => {
		EventBus.$emit("show_confirm",
			{
				"title": title,
				"html": "",
				worker : {
					resolve : resolve,
					reject : reject
				}
			});
	});

}
